import React, { useMemo, useState } from "react";
import { Manager } from "../manager/manager";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@shared/ui/tabs";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { ListFilterType } from "../../types";
import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/button";
import { logEvent } from "@amplitude/analytics-browser";
import { PlusCircle } from "lucide-react";

export const Lists = () => {
  const [filterType, setFilterType] = useState<ListFilterType | "all">("all");
  const [activeTab, setActiveTab] = useState("my-lists");
    const navigate = useNavigate();
  

  // Create tab components with the filter dropdown in the header
  const tabComponents = useMemo(
    () => ({
      "my-lists": {
        label: "My Lists",
        component: (
          <div className="mt-4">
            <Manager filterType={filterType} listOwnership="my-lists" />
          </div>
        ),
      },
      "all-lists": {
        label: "All Lists",
        component: (
          <div className="mt-4">
            <Manager filterType={filterType} listOwnership="all-lists" />
          </div>
        ),
      },
    }),
    [filterType]
  );

  return (
    <div className="px-4 mx-auto">
      <header className="flex justify-between mb-6">
        <span>
        <h1 className="page-title">Contact Lists</h1>
        <p className="page-subtitle">
          Create and manage lists of consumers, technicians, and business users.
        </p>
        </span>
        <Button
          onClick={() => {
            navigate(`/communication-hub/lists/new`);
            logEvent("Clicked on New List");
          }}
        >
          <PlusCircle className="mr-2 h-4 w-4" /> New List
        </Button>
      </header>

      <div className="w-full">
        <Tabs
          className="w-full"
          defaultValue="my-lists"
          urlMapping={{
            "my-lists": "my-lists",
            "all-lists": "all-lists",
          }}
          idPrefix="lists"
          tabsListClassName="grid w-full  grid-cols-2 sm:inline-grid border-b px-1 py-1"
          tabComponents={tabComponents}
        />
      </div>
    </div>
  );
};
